import { App } from "./App";
import { GuiBrowserGS } from "./GuiCtrlGS";
import { RuntimeEnvironmentGSEnum, RuntimeGS, RuntimeScopeGS } from "./RuntimeGS";

/** Browser application root. State execution lives behind the StateGS facade. */
export abstract class AppBrowser extends App {
    /** @internal */
    protected readonly environment = RuntimeEnvironmentGSEnum.Browser;
    private _scope?: RuntimeScopeGS;
    private _gui?: GuiBrowserGS;

    public override start(): Promise<void> {
        if (!this._scope) {
            const runtimeWindow = RuntimeGS.window;
            if (!runtimeWindow) throw new Error("AppBrowser requires a browser window.");
            this._scope = {
                app: this,
                environment: RuntimeEnvironmentGSEnum.Browser,
                instances: new Map<Function, unknown>(),
                document: runtimeWindow.document,
                window: runtimeWindow
            };
            RuntimeGS.setBrowserScope(this._scope);
            const root = runtimeWindow.document.querySelector(this.appRootSelector) as HTMLElement | null
                ?? runtimeWindow.document.body;
            this._gui = new GuiBrowserGS(root);
        }
        return super.start();
    }

    /** @internal */
    protected override createScope(): RuntimeScopeGS {
        if (!this._scope) throw new Error("Browser scope was not initialized.");
        return this._scope;
    }

    public get gui(): GuiBrowserGS {
        if (!this._gui) throw new Error("Browser GUI is unavailable before app.start().");
        return this._gui;
    }
}
